import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';
import { getResultOptions } from '../../../utils/data';

class DyeInspectionItemForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		itemInspected: Joi.string().min(3).required().label('Item Inspected'),
		size: Joi.number().min(1).required().label('Size (Inches)'),
		welderNo: Joi.string().required().label('Welder No'),
		observation: Joi.string().min(10).required().label('Observation'),
		result: Joi.string().min(3).required().label('Result'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Inspected Item(s)</h3>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'itemInspected',
							label: 'Item Inspected',
							placeholder: 'e.g. 1 weld joint',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'size',
							label: 'Size (Inches)',
							placeholder: 'e.g. Inches',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'welderNo',
							label: 'Welder No',
							placeholder: 'Enter Welder Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'observation',
							label: 'Observation',
							placeholder: 'Enter your Observation',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result.',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>
				</div>

				{this.renderButton('Add Row')}
			</form>
		);
	}
}

const initialData = {
	itemInspected: '',
	size: 0,
	welderNo: '',
	observation: '',
	result: '',
};

export default DyeInspectionItemForm;
